import _objectWithoutProperties from "/Users/oct16/work/Cat/timecat-issue-helper/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "h2",
    components: components
  }, "\u5728\u4F60\u5F00\u59CB\u4E4B\u524D..."), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u9996\u5148\uFF0C\u867D\u7136\u6211\u4EEC\u4E3A\u4E86\u4E2D\u6587\u7528\u6237\u7684\u65B9\u4FBF\u63D0\u4F9B\u4E86\u4E2D\u6587\u7684\u8868\u5355\uFF0C\u4F46\u5728\u586B\u5199\u65F6\u8BF7", /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "p"
  }, "\u5C3D\u91CF\u4F7F\u7528\u82F1\u6587"), "\u3002TimeCat \u671F\u671B\u505A\u6210\u4E00\u4E2A\u56FD\u9645\u5316\u7684\u5F00\u6E90\u9879\u76EE\uFF0C\u793E\u533A\u4E0D\u53EA\u6709\u4E2D\u56FD\u4EBA\u3002\u5982\u679C\u4F60\u60F3\u8BA9\u5C3D\u53EF\u80FD\u591A\u7684\u4EBA\u80FD\u591F\u770B\u61C2\u4F60\u7684 issue\uFF0C\u5C31\u8BF7\u5C3D\u91CF\u7528\u82F1\u6587\u3002\u5982\u679C\u62C5\u5FC3\u8868\u8FBE\u4E0D\u6E05\u695A\uFF0C\u53EF\u4EE5\u540C\u65F6\u63D0\u4F9B\u4E2D\u6587\u5185\u5BB9\u3002"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u5176\u6B21\uFF0C", /*#__PURE__*/React.createElement("a", {
    href: "https://github.com/oct16/TimeCat/issues",
    target: "_blank"
  }, "TimeCat issue"), " \u5217\u8868\u53EA\u63A5\u53D7 bug \u62A5\u544A\u6216\u662F\u65B0\u529F\u80FD\u8BF7\u6C42 (Feature Requests)\u3002\u8FD9\u610F\u5473\u7740", /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "p"
  }, "\u6211\u4EEC\u4E0D\u63A5\u53D7\u7528\u6CD5\u95EE\u9898"), "\u3002\u5982\u679C\u4F60\u5F00\u7684 issue \u4E0D\u7B26\u5408\u89C4\u5B9A\uFF0C\u5B83\u5C06\u4F1A\u88AB", /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "p"
  }, "\u7ACB\u523B\u5173\u95ED"), "\u3002", /*#__PURE__*/React.createElement(MDXTag, {
    name: "a",
    components: components,
    parentName: "p",
    props: {
      "href": "#intro-modal"
    }
  }, "\u4E3A\u4EC0\u4E48\u8981\u8FD9\u4E48\u4E25\u683C\uFF1F")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u5BF9\u4E8E\u4F7F\u7528\u4E2D\u9047\u5230\u7684\u95EE\u9898\uFF0C\u8BF7\u4F7F\u7528\u4EE5\u4E0B\u8D44\u6E90\uFF1A"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "ul",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, "\u4ED4\u7EC6\u9605\u8BFB ", /*#__PURE__*/React.createElement("a", {
    href: "https://github.com/oct16/TimeCat/blob/master/articles/quick-start.md",
    target: "_blank"
  }, "\u4F7F\u7528\u6587\u6863"))), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u6700\u540E\uFF0C\u5728\u5F00 issue \u524D\uFF0C\u53EF\u4EE5\u5148\u641C\u7D22\u4E00\u4E0B\u4EE5\u5F80\u7684\u65E7 issue - \u4F60\u9047\u5230\u7684\u95EE\u9898\u53EF\u80FD\u5DF2\u7ECF\u6709\u4EBA\u63D0\u4E86\uFF0C\u4E5F\u53EF\u80FD\u5DF2\u7ECF\u5728\u6700\u65B0\u7248\u672C\u4E2D\u88AB\u4FEE\u6B63\u3002\u6CE8\u610F\uFF1A\u5982\u679C\u4F60\u53D1\u73B0\u4E00\u4E2A\u5DF2\u7ECF\u5173\u95ED\u7684\u65E7 issue \u5728\u6700\u65B0\u7248\u672C\u4E2D\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u4E0D\u8981\u5728\u65E7 issue \u4E0B\u9762\u7559\u8A00\uFF0C\u800C\u5E94\u8BE5\u7528\u4E0B\u9762\u7684\u8868\u5355\u5F00\u4E00\u4E2A\u65B0\u7684 issue\u3002"));
});